import React from "react";

// ErrorBoundary — ultima rete di sicurezza dell'app. Se un errore di rendering non
// gestito arriva fin qui, mostriamo una schermata di cortesia invece di una pagina
// bianca. Deve restare una classe: React supporta getDerivedStateFromError/
// componentDidCatch solo sui class component, non c'è un equivalente a hook.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Errore non gestito catturato da ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
          background: "#f8fafc", fontFamily: "'Inter',sans-serif", padding: 24
        }}>
          <div style={{
            maxWidth: 420, textAlign: "center", background: "#fff", borderRadius: 16,
            padding: "40px 32px", boxShadow: "0 4px 24px rgba(0,0,0,.08)", border: "1px solid #e2e8f0"
          }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
            <h2 style={{ margin: "0 0 10px", color: "#1e1b4b", fontSize: 19 }}>
              Si è verificato un errore imprevisto
            </h2>
            <p style={{ margin: "0 0 24px", color: "#475569", fontSize: 14, lineHeight: 1.5 }}>
              Nexiora ha riscontrato un problema e non può continuare in questa pagina.
              I tuoi dati salvati non sono a rischio: ricaricando si riparte dalla Home.
            </p>
            <button
              onClick={() => {
                // W421: si riparte dalla Home. Nexiora ricorda l'ultima schermata nella
                // cronologia della scheda: senza questa riga la ricarica riapriva la stessa
                // schermata con lo stesso errore, all'infinito.
                try { window.history.replaceState(null, ""); } catch { /* cronologia non disponibile */ }
                window.location.reload();
              }}
              style={{
                background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9,
                padding: "11px 26px", fontSize: 14, fontWeight: 700, cursor: "pointer",
                fontFamily: "'Inter',sans-serif"
              }}
            >
              Ricarica la pagina
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
